import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import * as React from "react";
import {Component} from "react";
import {CardBody, Col, Row} from "reactstrap";
import {Field} from "redux-form";
import DummyActionsRow from "../../components/DummyActionsRow";
import {field} from "@mc/mc-legacy";
import * as Barevnost from "../../api/gen/cgo/Barevnost";
import * as BarevnostInfo from "../../api/BarevnostInfo";
import * as EnumPokryti from "../../api/gen/cgo/EnumPokryti";
import * as EnumPokrytiInfo from "../../api/EnumPokrytiInfo";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Položka v seznamu pro import položek.
 * Na základě isActive se vyrenderuje buďto read-only nebo s input fieldy pro editaci.
 */
class ImportPolozkyField extends Component<WithTranslation> {

    static propTypes = {
        field: PropTypes.string.isRequired, // název fieldu
        polozka: PropTypes.object.isRequired, // VO položky
        index: PropTypes.number.isRequired, // index dané položky v seznamu
        isActive: PropTypes.bool.isRequired, // zda je tato položka právě aktivní (vyrenderuje se s inputy)
        onClick: PropTypes.func.isRequired, // callback při kliknutí na položku, předpis: (index) => {...}
    };

    getShortNazev = (nazev) => {
        // chceme zobrazovat pouze název souboru, ne celou cestu
        return nazev ? nazev.split('\\').slice(-1)[0].split('/').slice(-1)[0] : null;
    };

    renderNazevField = ({input}) => {
        return <field.String {...input} value={this.getShortNazev(input.value)} />;
    };

    renderIntField = ({input}) => (
        <field.Number int {...input} />
    );

    renderDoubleField = ({input}) => (
        <field.Number double {...input} />
    );

    renderBarevnostField = ({input}) => {
        const {t} = this.props;
        return <field.Select {...input}>
            {Barevnost.values.map(barevnost => <option key={barevnost}
                                                        value={barevnost}>{BarevnostInfo.getCaption(barevnost, t)}</option>)}
        </field.Select>
    };

    renderSkladatField = ({input}) => {
        const {t} = this.props;
        return <field.Select {...input}>
            <option value="true">{t('fold')}</option>
            <option value="false">{t('dont_fold')}</option>
        </field.Select>
    };

    renderPokrytiField = ({input}) => {
        const {t} = this.props;
        return <field.Select {...input}>
            {EnumPokryti.values.map(pokryti => <option key={pokryti} value={pokryti}>{EnumPokrytiInfo.getCaption(pokryti, t)}</option>)}
        </field.Select>
    };

    render() {
        const {field, polozka, index, isActive, onClick, t} = this.props;
        let content;
        if (isActive) {
            content = <Row>
                <Col xs={3}>
                    <Field
                        name={`${field}.nazev`}
                        component={this.renderNazevField}
                    />
                </Col>
                <Col xs={1}>
                    <Field
                        name={`${field}.x`}
                        component={this.renderDoubleField}
                    />
                </Col>
                <Col xs={1}>
                    <Field
                        name={`${field}.y`}
                        component={this.renderDoubleField}
                    />
                </Col>
                <Col xs={1}>
                    <Field
                        name={`${field}.pocet`}
                        component={this.renderIntField}
                    />
                </Col>
                <Col xs={2}>
                    <Field
                        name={`${field}.pokryti`}
                        component={this.renderPokrytiField}
                    />
                </Col>
                <Col xs={2}>
                    <Field
                        name={`${field}.barevnost`}
                        component={this.renderBarevnostField}
                    />
                </Col>
                <Col xs={2}>
                    <Field
                        name={`${field}.skladat`}
                        component={this.renderSkladatField}
                        format={value => value === true ? "true" : value === false ? "false" : "null"}
                        normalize={value => value === "null" ? null : value === "true"}
                    />
                </Col>
            </Row>
        } else {
            content = <Row>
                <Col xs={3} className="read-only" title={polozka.nazev}>{this.getShortNazev(polozka.nazev)}</Col>
                <Col xs={1}>{Math.round(polozka.x * 100) / 100}</Col>
                <Col xs={1}>{Math.round(polozka.y * 100) / 100}</Col>
                <Col xs={1}>{polozka.pocet}</Col>
                <Col xs={2}>{EnumPokrytiInfo.getCaption(polozka.pokryti, t)}</Col>
                <Col xs={2}>{BarevnostInfo.getCaption(polozka.barevnost, t)}</Col>
                <Col xs={2}>{polozka.skladat ? t('fold') : t('dont_fold')}</Col>
            </Row>
        }
        return <CardBody onClick={onClick.bind(this, index)}>
            <DummyActionsRow>
                {content}
            </DummyActionsRow>
        </CardBody>
    }
}

export default connect()(withTranslation()(ImportPolozkyField));
